
  import { Vue, Component, Prop } from "vue-property-decorator";
  import { NO_INFORMATION } from "@/data/placeholders";
  import RouteParams from "@/entities/RouteParams";

  @Component
  export default class CardItemValue extends Vue {
    @Prop({ type: String, default: undefined }) readonly value?: string;
    @Prop({ type: Boolean, default: false }) readonly highlighted!: boolean;
    @Prop({ type: Object, default: () =>({}) }) readonly routeParams!: Partial<RouteParams<{ id: string }>>;

    get isLink(): boolean {
      return Boolean(this.routeParams.name);
    }

    get content(): string {
      return this.value || NO_INFORMATION;
    }

    get classes(): Record<string, boolean> {
      if (!this.value) {
        return {};
      }

      return {
        ["font-bold"]: this.highlighted,
      };
    }
  }
